import { render, staticRenderFns } from "./BnplB2bApplications.vue?vue&type=template&id=0cf156ea&scoped=true&"
import script from "./BnplB2bApplications.vue?vue&type=script&lang=js&"
export * from "./BnplB2bApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf156ea",
  null
  
)

export default component.exports